import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { LOGOUT } from '@store/actions';
import { Store } from '@ngrx/store';
import { AuthenticationState } from '@store/reducers';
import { filter, Observable, Subject, takeUntil } from 'rxjs';
import { Credential } from '@core/models';
import { selectCredential } from '@store/selectors/authentication.selectors';

@Component({
  selector: 'app-profilemenu',
  templateUrl: './app.profilesidebar.component.html',
})
export class AppProfileSidebarComponent implements OnInit, OnDestroy {
  credential$: Observable<Credential | null>;
  userFullname?: string;

  private destroy$ = new Subject<void>();
  
  constructor(
    private store: Store<AuthenticationState>,
    public layoutService: LayoutService
  ) {
    this.credential$ = this.store.select(selectCredential);
  }

  ngOnInit(): void {
    this.credential$
      .pipe(
        filter((credential): credential is Credential => !!credential && !!credential.cuentas),
        takeUntil(this.destroy$),
      )
      .subscribe(({ nombre }) => {
        this.userFullname = nombre;
      });
  }

  get visible(): boolean {
    return this.layoutService.state.profileSidebarVisible;
  }

  set visible(_val: boolean) {
    this.layoutService.state.profileSidebarVisible = _val;
  }

  onSignOut(): void {
    this.layoutService.hiddeProfileSidebar()
    this.store.dispatch(LOGOUT());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
